import ExtendableError from 'es6-error';

export class AuthorizationError extends ExtendableError {}
export class BadRequestError extends ExtendableError {}
export class NetworkError extends ExtendableError {}
export class NotFoundError extends ExtendableError {}
export class OfflineError extends ExtendableError {}
export class ServiceUnavailableError extends ExtendableError {
  constructor(message: string, public type?: string) {
    super(message);
  }
}
export class RequestError extends ExtendableError {}
export class UpdateRequiredError extends ExtendableError {}
export class UpdateFailedError extends ExtendableError {}
export class OperationFailedError extends ExtendableError {}
export class DuplicateDataError extends ExtendableError {}
export class InsertionFailedError extends ExtendableError {}
export class CodeSyntaxError extends ExtendableError {}
